import { LogOut, Menu } from "lucide-react";
import { useState, useEffect } from "react";
// import { useAuth } from "../store/hooks/useAuth";
import { Badge, Button, Image } from "react-bootstrap";
import { getUserDetails } from "../../../utils/helper";
import audioUrl from '../../../assets/sounds/notification_sound.mp3';
import authApi from "../../../api/authApi";
import { useNavigate, useLocation, NavLink } from "react-router-dom";
import { ROUTES } from "../../../constants/webRouting";
import solisPowerApi from "../../../api/solisPowerApi";
import Notification from "../common/Notification";
import UserImage from "../../../assets/img/img_avatar.png"

export default function Header({ onLogout, onToggleSidebar, socket }) {
  const [audio] = useState(new Audio(audioUrl));
  const [user, setUsers] = useState();
  const [userInfo, setUserInfo] = useState(getUserDetails() || null);
  const [refreshNotification, setRefreshNotification] = useState(new Date());
  const [showBellAlert, setShowBellAlert] = useState(false);
  const [unreadMsgCount, setUnreadMsgCount] = useState(0);
  const [messages, setMessages] = useState(0);
  const [showNotification, setShowNotification] = useState(false);
  const navigate = useNavigate();


  useEffect(() => {
    // console.log("header rend")
    const token = localStorage.getItem("token");
    if (!token) {
      navigate(ROUTES.LOGIN);
    } else {
    }

    //Added by shahir hussain 21-08-2025
    // init(false, false);

    messageList(false, false);
    // console.log("socket =>", socket?.on)
    // messageList(false); 


    if (!socket?.on) return;
    const onGreetings = () => {
      messageList(true, true);
    };
    const onTaskReminder = () => {
      messageList(true, true);
    };
    socket.on("greetings", onGreetings);
    socket.on("taskReminder", onTaskReminder);
    return () => {
      socket.off("greetings", onGreetings);
      socket.off("taskReminder", onTaskReminder);
    };
  }, [socket]);

  async function init(open, play) {
    let result = await solisPowerApi.fetchUnreadMessages();
    // console.log('result', result);
    //let tasks = [];
    //  console.log("tasks.length", tasks)
    if (result && result?.length > 0) {
      result.forEach((message) => {
        message.description = formatMessage(message.description);
      });


      const readMessages = result.filter((message) => message.status === "New");
      setUnreadMsgCount(readMessages.length);
      setMessages(result);
      setShowNotification((prev) => !prev);
      setShowBellAlert((prev) => !prev);

      if (play) {
        playBellSound();
      }
    } else {
      setMessages([]);
      setUnreadMsgCount(0);
      setShowNotification(open);
    }

    open && setShowNotification(true);
  }
  const messageList = (open, play) => {
    // console.log("task");
    init(open, play);

  };

  const formatMessage = (mystr) => {
    let oldStr = mystr;
    mystr = mystr.substring(1);
    var arry = mystr.split(" @");
    var returnArr = [];

    for (var a of arry) {
      var obj = {};
      var value = a.substring(a.lastIndexOf("[") + 1, a.lastIndexOf("]"));
      var key = a.substring(a.lastIndexOf("(") + 1, a.lastIndexOf(")"));
      obj[`username`] = value;
      obj[`id`] = key;
      if (key) returnArr.push(obj);
    }

    for (var a of returnArr) {
      oldStr = oldStr.replace(
        `@[${a.username}](${a.id})`,
        `<a href="/users/${a.id}">${a.username}</a>`
      );
    }

    return oldStr;
  };

  const playBellSound = async () => {
    const audio = new Audio(audioUrl);
    console.log('Audio result', await audio?.play());
    audio?.play()?.catch((e) => console.error('Playback error:', e));
  };

  const logout = async () => {
    await authApi.logout();
    navigate(ROUTES.LOGIN);
  };

  const closeNotification = () => {
    setShowNotification(false);
  };

  const openNotificationArea = () => {
    // console.log("showNotification == ", showNotification)
    if (!showNotification) {
      messageList(true, true);
      setShowNotification(true);
    }
    else setShowNotification(false);

    setShowBellAlert(false);
  };

  /* Added by Farhan Khan on 12-Feb-2026 - Header: fixed at top, 60px height, no layout shift */
  return (
    <header className="crm-header bg-white border-b border-gray-200 flex items-center justify-between header-navbar">
      {/* LEFT SIDE */}
      <div className="flex items-center gap-4">
        {/* Sidebar Toggle Button */}
        <button
          onClick={onToggleSidebar}
          className="p-2 rounded-lg bg-white border-0 transition"
        >
          <Menu className="w-6 h-6 text-gray-700" />
        </button>

        {/* Avatar */}
        <div className="w-10 h-10 rounded-full flex items-center justify-center bg-blue-600 text-white font-semibold" style={{ height: "27px" }}>
          <Image
            variant="top"
            src={UserImage}
            className="rounded-circle"
            thumbnail
            style={{ width: "400px" }}
          ></Image>
          <Badge
            style={{ fontSize: ".9rem", color: "#1b1313" }}
            bg="#244c7e"
          >
            {userInfo?.username}
          </Badge>
          <Badge
            bg="secondary"
            style={{ fontSize: "5px !important", position: "relative" }}
          >
            {userInfo?.userroleA === "SYS_ADMIN"
              ? "SUPER ADMIN"
              : userInfo?.userroleA} (
            {userInfo.user_type}
            )

          </Badge>
        </div>


      </div>



      <div className="d-flex align-items-center justify-content-end gap-3 w-100">

        {/* Notification */}
        <div>
          <span
            onClickCapture={playBellSound}
            onClick={openNotificationArea}
            className="position-relative d-inline-block"
            style={{ cursor: "pointer" }}
          >
            <i className="fs-5 fa fa-bell fa-regular"></i>

            {unreadMsgCount > 0 && (
              <span
                className="position-absolute top-0 start-100 translate-middle bg-danger text-white rounded-pill"
                style={{
                  fontSize: "10px",
                  padding: "2px 5px",
                  minWidth: "16px",
                  lineHeight: "1"
                }}
              >
                {unreadMsgCount}
              </span>
            )}
          </span>
        </div>

        {/* Logout */}
        <button onClick={onLogout} className="d-flex align-items-center gap-1 custom-btn-logout">
          <LogOut className="w-4 h-4" />
          <span>Logout</span>
        </button>

      </div>

      {showNotification && (
        <Notification
          notifications={messages}
          closeNotification={closeNotification}
          refreshNotification={refreshNotification}
          messageList={messageList}
          setShowNotification={setShowNotification}
        />
      )}


    </header>
  );
}